const state = {
  uid: "",
  token: "",
  userType: 1,
  username: "",
  account: ""
};

const mutations = {
  SET_USERDATA: (state, data) => {
    (state.uid = data.uid),
      (state.token = data.token),
      (state.userType = data.userType);
  },
  SET_USERNAME: (state, data) => {
    (state.username = data.username), (state.account = data.account);
  }
};

const actions = {
  setUserData({ commit }, userinfo) {
    commit("SET_USERDATA", userinfo);
  },
  setUserName({ commit }, user) {
    commit("SET_USERNAME", user);
  }
};

export default {
  state,
  mutations,
  actions
};
